import {
  erroreCampoObbligatorio,
  erroreFormatoEmail,
  erroreCaratteriNonValidi,
} from "_constants";
import { Chips } from "primereact/chips";
import { Control, Controller } from "react-hook-form";
import { emailRegex, noEmojiRegex } from "utils";

export const FormShareAnswer = ({ control }: { control: Control<any> }) => {
  
  return (
    <Controller
      name="emailList" // Nome del campo associato
      control={control}
      defaultValue={[]} // DefaultValue qui può essere vuoto o un array di email iniziali
      rules={{
        validate: {
          required: (value) =>
            Array.isArray(value) && value.length > 0
              ? true
              : erroreCampoObbligatorio,

          emailFormat: (value) =>
            value.every((email: string) => emailRegex.test(email)) ||
            erroreFormatoEmail,

          noEmoji: (value) =>
            value.every((email: string) => !noEmojiRegex.test(email)) ||
            erroreCaratteriNonValidi,
        },
      }}
      render={({ field, fieldState: { error, isTouched } }) => (
        <div className="flex-container column width-100">
          <Chips
            id={field.name}
            value={field.value}
            onChange={(e) => field.onChange(e.value)}
            invalid={error ? true : false}
            className="width-100 custom-chips-multiple"
            allowDuplicate={false}
          />
          <small className="p-error margin-top-4">{error?.message}</small>
        </div>
      )}
    />
  );
};
